"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./Tooltip.scss");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0, _defineProperty2["default"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
    content = _ref.content,
    isVisible = _ref.isVisible,
    hasPositionCalculated = _ref.hasPositionCalculated,
    positionConfig = _ref.positionConfig,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    onClick = _ref.onClick,
    wrapperRef = _ref.wrapperRef,
    contentRef = _ref.contentRef,
    _ref$hasTriggerWidth = _ref.hasTriggerWidth,
    hasTriggerWidth = _ref$hasTriggerWidth === void 0 ? false : _ref$hasTriggerWidth,
    className = _ref.className,
    triggerClassName = _ref.triggerClassName,
    contentClassName = _ref.contentClassName,
    wrapperClassName = _ref.wrapperClassName;
  var rootClassName = (0, _classnames["default"])('cds-Tooltip', className);
  var triggerComponentClassName = (0, _classnames["default"])('cds-Tooltip-Trigger', triggerClassName);
  var portalClassName = (0, _classnames["default"])('cds-Tooltip-Content', "cds-Tooltip-Content--".concat(positionConfig.orientation), {
    'cds-Tooltip-Content--FullWidth': hasTriggerWidth
  }, contentClassName);
  var Portal = function Portal(_ref2) {
    var left = _ref2.left,
      top = _ref2.top,
      width = _ref2.width,
      className = _ref2.className;
    return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement("div", {
      style: _objectSpread(_objectSpread({
        left: left,
        top: top
      }, !hasPositionCalculated && {
        opacity: 0
      }), hasTriggerWidth && {
        width: width
      }),
      className: (0, _classnames["default"])('cds-Tooltip-PortalWrapper', className)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: portalClassName,
      ref: contentRef
    }, content)), document.body);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: wrapperRef,
    className: rootClassName,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: triggerComponentClassName
  }, children), isVisible && content && /*#__PURE__*/_react["default"].createElement(Portal, {
    left: positionConfig.left,
    top: positionConfig.top,
    width: positionConfig.width,
    className: wrapperClassName
  }));
};
exports.Tooltip = Tooltip;